import { updateState } from 'utils';
import loginActions from './LoginActions';

const initialState = {
  user: null,
  isAdmin: false,
  successMessage: null,
  errorMessage: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case loginActions.SIGN_IN:
      return updateState(state, { user: action.payload });

    case loginActions.SET_IS_ADMIN:
      return updateState(state, { isAdmin: action.payload });

    case loginActions.SET_IS_ADMIN_SUCCESS:
      return updateState(state, { successMessage: action.payload });

    case loginActions.SET_IS_ADMIN_ERROR:
      return updateState(state, { errorMessage: action.payload });

    case loginActions.SIGN_IN_ERROR:
      return updateState(state, { errorMessage: action.payload });

    case loginActions.RESET_ERROR:
      return updateState(state, { errorMessage: action.payload });

    case loginActions.RESET_SUCCESS:
      return updateState(state, { successMessage: action.payload });

    default:
      return state;
  }
};
